import { render, staticRenderFns } from "./CoachHeader.vue?vue&type=template&id=2e785041&"
import script from "./CoachHeader.vue?vue&type=script&lang=js&"
export * from "./CoachHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports